import { render } from "./ClientSpaceResume.vue?vue&type=template&id=97f40e18&scoped=true"
import script from "./ClientSpaceResume.vue?vue&type=script&lang=js"
export * from "./ClientSpaceResume.vue?vue&type=script&lang=js"

import "@/assets/scss/_clientSpaceResume.scss?vue&type=style&index=0&id=97f40e18&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97f40e18"]])

export default __exports__